<template>
  <li class="sidenav-item dropdown">
    <span
      class="sidenav-item__parent"
      :class="{ open: showChildren }"
      @click="toggleDropdown"
    >
      <span class="sidenav-item__icon">
        <slot name="icon"></slot>
      </span>
      <span class="sidenav-item__title" :class="{ 'sidenav-item__title-collapse': isSideNavCollapsed }">
        {{ title }}
      </span>
      <span class="sidenav-item__dropdown-icon">
        <svg
          :class="{ open: showChildren }"
          class="dropdown-icon"
          width="6"
          height="10"
          viewBox="0 0 6 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 9L5 5L1 1"
            stroke="#ffffff"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </span>
    </span>
    <div
      :class="{ show: showChildren }"
      ref="dropdownChild"
      class="sidenav-item__children"
    >
      <slot name="children"> </slot>
    </div>
  </li>
</template>

<script>
export default {
  props: {
    title: String,
    url: String,
  },
  data() {
    return {
      showChildren: false,
    };
  },
  computed: {
    isSideNavCollapsed() {
      return this.$store.getters.isSideNavCollapsed;
    },
  },
  methods: {
    toggleDropdown() {
      let childContent = this.$refs.dropdownChild;
      if (childContent.style.maxHeight) {
        childContent.style.maxHeight = null;
        childContent.style.marginBottom = null;
      } else {
        childContent.style.maxHeight = childContent.scrollHeight + 6 + "px";
        childContent.style.marginBottom = "1rem";
      }
      this.showChildren = !this.showChildren;
    },
  },
};
</script>

<style lang="scss" scoped>
.sidenav-item.dropdown {
  cursor: pointer;
}

.sidenav-item__parent {
  display: flex;
  align-items: center;
  height: 100%;
  padding-top: 0.6rem;
  padding-bottom: 0.6rem;
  padding-left: 2rem;
  &.open {
    background: #ebf2fa;
    box-shadow: 0px 10px 20px rgba(15, 49, 92, 0.3);
    border-radius: 50px;

    .sidenav-item__title {
      color: var(--primaryblue);
    }
    .dropdown-icon path {
      stroke: var(--primaryblue);
    }
    .sidenav-item__icon > * {
      fill: var(--primaryblue);
    }
  }
}

.sidenav-item__icon {
  margin-right: 1rem;
}

.sidenav-item__title {
  color: #ffffff;
  font-size: 0.9rem;
}
.sidenav-item__title-collapse{
  display: none;
}

.sidenav-item__children {
  display: flex;
  flex-direction: column;
  max-height: 0;
  overflow: hidden;
  transition: all ease 0.5s;
}

.sidenav-item__children.show {
  height: auto;
}

.sidenav-item__children a {
  color: #ffffff;
  font-weight: normal;
  padding: 0.5rem 0 0.5rem 3rem;
  font-size: 0.9rem;
}
.sidenav-item__children > .router-link-active {
  color: #ffffff;
  font-weight: bold;
}
.sidenav-item__children a:hover {
  text-decoration: none;
}
.sidenav-item__dropdown-icon {
  margin-left: auto;
  margin-right: 1.5rem;
}
.dropdown-icon {
  transition: all ease 0.5s;
}
.dropdown-icon.open {
  transform: rotate(90deg);
}
svg {
  display: inline-block;
}
</style>
